import { Box, Button, CircularProgress, Paper, Typography, useTheme, Tab, Tabs, Card, Tooltip, Popper, ClickAwayListener, MenuList, MenuItem } from '@mui/material'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import AnswerSection from '../../components/admission-exam-components/AnswerSection'
import QuestionList from '../../components/admission-exam-components/QuestionList'
import { useParams, useNavigate } from 'react-router-dom'
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import api from '../../service/api'
import { erpResultsPageLink, Icons, shuffleArray } from '../../utils/utilities'
import { useAdmissionExamStore } from '../../store/admission-exam.store'
import { useUserStore } from '../../store/user.store'
import TryAgainMessageBlock from '../../components/common/TryAgainMessageBlock'
import fullScreenImg from '../../assets/full-screen.svg'
import DataLoadingSpinner from '../../components/common/DataLoadingSpinner'
import ExamAttemptHeader from '../../components/admission-exam-components/ExamAttemptHeader'
import { observer } from 'mobx-react'
import { by639_1 } from 'iso-language-codes'
import LanguageSelector from '../../components/admission-exam-components/LanguageSelector'
import { useTranslation } from 'react-i18next'

const getInstructionByLang = ( rawInstructions ) => {
    if ( !rawInstructions ) return ""

    let langCode = localStorage.getItem( 'preferedLanguage' ) || "uz"

    if ( !rawInstructions.match( new RegExp( `--${langCode}`, "i" ) ) ) {
        langCode = "en"
    }

    const regex = new RegExp(
        `<p>\\s*--${langCode}\\s*<\\/p>([\\s\\S]*?)<p>\\s*${langCode}--\\s*<\\/p>`,
        "i"
    )

    const match = rawInstructions.match( regex )

    if ( match ) {
        // match[1] contains the HTML content between the delimiters
        return match[1].trim()
    }

    return rawInstructions
}

const AdmissionExamAttempt = observer( () => {
    // const [currentIndex, setCurrentIndex] = useState( 0 )
    // const [submissions, setSubmissions] = useState( null )
    // const [currentQuestion, setCurrentQuestion] = useState( null )
    // const [questions, setQuestions] = useState( null )
    const [exam, setExam] = useState( null )
    const [timeLeft, setTimeLeft] = useState( '' )
    const [participation, setParticipation] = useState( null )
    const [isExamStarted, setIsExamStarted] = useState( false )
    const [showQuestions, setShowQuestions] = useState( true )
    const [isStarting, setIsStarting] = useState( false )
    const [finishDialog, setFinishDialog] = useState( false )
    const [isSubmitting, setIsSubmitting] = useState( false )
    const [showWarning, setShowWarning] = useState( false )
    const [saving, setSaving] = useState( false )
    const [error, setError] = useState( null )
    // const [faultCount, setFaultCount] = useState( 0 )
    // const [section, setSection] = useState( "" )
    // const [questionSections, setAllQuestionSections] = useState( [] )
    // const [filteredQuestions, setFilteredQuestions] = useState( [] )
    const [loading, setLoading] = useState( true )

    const navigate = useNavigate()

    const ExamStore = useAdmissionExamStore()
    const UserStore = useUserStore()

    const { palette, border, theme } = useTheme()
    const { id, pid, attempt } = useParams()
    const { t } = useTranslation()

    const examAttemptFullScreenHandle = useFullScreenHandle()

    const fullscreeBtnRef = useRef()
    const fullscreenHelperInputRef = useRef()

    const questions = ExamStore.getAttemptQuestions || []
    const filteredQuestions = ExamStore.getAttemptQuestions || []
    const currentQuestion = ExamStore.getAttemptDetails.currentQuestion
    const questionSections = ExamStore.getAttemptDetails.sections
    const section = ExamStore.getAttemptDetails.currentSection
    const submissions = ExamStore.getAttemptSubmissions || {}
    const { translationsAvailable = false } = ExamStore.getTranslationDetails || {}

    const handleChange = ( event, newValue ) => {
        ExamStore.setCurrentAttemptSection( newValue )
    }

    const navigateToResultsPage = () => {
        navigate( `/admission-exam/registration` )
    }

    const saveAnswer = async ( answer, type, selectionType ) => {

        if ( answer ) {
            if ( String( answer ).trim() !== '' ) {
                setSaving( true )
                try {
                    const res = await api.admissionExams.submitAnswer( id, pid, { answer, qid: currentQuestion.question.question_id, type, selectionType, remainingDuration: ExamStore.currentRemainingTime } )

                    if ( res.status === 200 ) {
                        await ExamStore.fetchAttemptSubmissions( id, pid )
                        toast( t( "message.answerSaved" ), { position: "top-center", containerId: "answer-toast" } )
                    }

                    await enterFullScreen()

                } catch ( e ) {
                    console.log( e )
                    if ( e?.response?.status === 401 || e?.response?.data?.unauth ) {
                        UserStore.setERPSessionState( "ended" )
                    }
                    else
                        toast( ( e.response && e.response.data ) ? e.response.data : "Something went wrong! submit answer again", { containerId: "answer-toast" } )
                } finally {
                    setSaving( false )
                }
            } else toast( "No answer given for previous question!", { position: "bottom-right", containerId: "answer-toast" } )
        } else toast( "No answer given for previous question!", { position: "bottom-right", containerId: "answer-toast" } )
    }

    const handleClickOnFinishExam = () => {
        if ( submissions?.length !== questions?.length )
            return toast( "Iltimos barcha savollarga to’liq javob bering", { position: "bottom-right" } )
        setFinishDialog( true )
    }

    const checkForReload = ( e ) => {
        if ( e.code === 'F5' )
            e.preventDefault()
        e = e || e.window.event
        if ( e.ctrlKey ) {
            var c = e.which || e.keyCode
            if ( c === 82 ) {
                e.preventDefault()
                e.stopPropagation()
            }
        }
    }

    const handleFullScreenChange = async ( state, handle ) => {
        if ( isExamStarted && state === false ) {
            // setFaultCount( prev => prev + 1 )
            setShowWarning( "fullscreenexit" )
            if ( examAttemptFullScreenHandle?.active === false ) {
                await fullscreenHelperInputRef?.current?.focus()
                await fullscreenHelperInputRef?.current?.click()
                await fullscreeBtnRef?.current?.click()
            }
        }
    }

    const handleScreenChange = useCallback( ( e ) => {
        if ( isExamStarted ) {
            // setFaultCount( prev => prev + 1 )
            // setShowWarning( "windowchange" )
        }
    }, [isExamStarted] )

    const startExam = async () => {
        setIsStarting( true )
        try {
            await enterFullScreen()

            const success = await ExamStore.startExam( id, pid )
            if ( success ) {
                setIsExamStarted( true )
            }
            return true
        } catch ( e ) {
            try { await examAttemptFullScreenHandle.exit() }
            catch ( err ) { }

            if ( e?.response?.status === 401 || e?.response?.data?.unauth ) {
                UserStore.setERPSessionState( "ended" )
            }
            else
                toast( e?.response?.data?.message || "Something went wrong! try to start exam again", { containerId: "main" } )
        } finally {
            setIsStarting( false )
        }
    }

    const enterFullScreen = async () => {
        try {
            if ( examAttemptFullScreenHandle?.active === false )
                await examAttemptFullScreenHandle.enter()
        } catch ( err ) { }
    }

    const finishExam = useCallback( async ( reason = "TimeUP", answeredQuestion, totalQuestions ) => {
        try {
            if ( answeredQuestion !== totalQuestions && reason !== "TimeUP" ) {
                toast( t( "message.answerAllQuestions" ) )
                return
            }
            const { data } = await api.admissionExams.finishExam( id, pid, { reason } )
            localStorage.setItem( 'admission_exam_candidate_id', data?.user_id )
            toast( t( "message.submittedSuccessfully" ), { containerId: "main" } )
            navigate( `/thankyou`, { replace: true } )
        }
        catch ( e ) {
            if ( e?.response?.status === 401 || e?.response?.data?.unauth ) {
                UserStore.setERPSessionState( "ended" )
            }
            else
                toast.error( e?.response?.data?.message || "Something went wrong while submitting you answers", { containerId: "main" } )
        }
    }, [UserStore, navigate, id, pid] )

    const toggleQuestions = () => {
        setShowQuestions( ps => !ps )
    }

    useEffect( () => {
        window.addEventListener( 'keydown', checkForReload )
        window.addEventListener( 'blur', handleScreenChange )

        return () => {
            window.removeEventListener( 'keydown', checkForReload )
            window.removeEventListener( 'blur', handleScreenChange )
        }
    }, [handleScreenChange] )

    const getData = useCallback( async () => {
        try {
            setLoading( true )
            const { success, error } = await ExamStore.fetchExam( id )
            ExamStore.fetchExamLanguages( id )

            if ( success ) {
                setError( null )
            } else {
                setError( error )
                return
            }
            const participation = await api.admissionExams.fetchParticipationData( id, pid )
            if ( String( participation.data.participation.exam_participation_end_time ) !== String( null ) || participation.data.participation.exam_participation_status === 'Completed' ) {
                // toast( "The attempt you tried to acess already ended!", { containerId: "main" } )
                return setError( { code: 400, message: "The attempt you tried to acess already ended", error: "ENDED" } )
            }
            await ExamStore.fetchAttemptSubmissions( id, pid )
            setParticipation( participation.data?.participation )

            // setAllQuestionSections( ExamStore.getExam.sections )
            // setSubmissions( uniqueSubmissions( sData.data || [] ) )
            setExam( ExamStore.getExam.exam )
            setError( null )
        } catch ( e ) {
            console.log( e )

            if ( e?.response?.status === 401 || e?.response?.data?.unauth ) {
                UserStore.setERPSessionState( "ended" )
            } else {
                setError( { code: e?.response?.status, message: e?.response?.data?.message || "Something went wrong! try again later" } )
            }
        } finally {
            setLoading( false )
        }
    }, [id, pid, ExamStore, UserStore] )

    useEffect( () => {
        getData()
    }, [getData] )

    // useEffect( () => {

    //     const registerFault = async () => {
    //         if ( faultCount > +( participation?.participation?.faults_made || 0 ) ) {
    //             try {
    //                 await api.admissionExams.registerExamAttemptFault( id, pid, { faultCount } )
    //             } catch ( err ) { }
    //         }
    //         if ( faultCount >= ExcusesCount ) {
    //             setIsExamStarted( ps => false )
    //             finishExam( "MaximumFaultsReached" )
    //         }
    //     }
    //     registerFault()
    // }, [finishExam, faultCount, id, pid, participation] )

    // useEffect( () => {
    //     if ( section && questionSections.length > 0 ) {
    //         const filtered = questions.filter( q => q.question.question_section === section )
    //         setFilteredQuestions( filtered )
    //         setCurrentIndex( 0 )
    //         setCurrentQuestion( filtered[0] )
    //     }
    // }, [section, questions, questionSections] )


    return (

        <FullScreen handle={examAttemptFullScreenHandle} onChange={handleFullScreenChange} className={`full-screen-element ${theme === 'dark' ? 'dark' : 'light'}`}>
            <ToastContainer containerId="answer-toast" position='bottom-left' autoClose={3000} hideProgressBar closeOnClick theme='dark' style={{ fontSize: "12px", zIndex: 100000000 }} />
            {loading && <DataLoadingSpinner waitingMessage={t( "attempt.loadingDetails" )} />}

            {!loading && !isExamStarted && !error && exam && <Box flexGrow={1} display="flex" flexDirection="column" minWidth="0" overflow="auto">
                <Box sx={{ borderRadius: "0", paddingBottom: "1px", overflow: "auto", display: "flex", flexDirection: "column", }}>
                    <Box padding="20px" bgcolor={palette.primary.main} display="flex" flexDirection="column" gap="5px" color="white">
                        <Typography variant='h5'>{exam.exam_name}</Typography>
                        <Typography variant='subtitle2'>{exam.exam_duration !== null && exam.exam_duration !== "null" ? `${t( "attempt.duration" )}: ` + exam.exam_duration : ""}</Typography>
                        <Typography variant='body2'>{t( "attempt.attemptNumber" )}: {attempt}</Typography>
                    </Box>


                    <Box flexGrow={1} className="custom-scrollbar" overflow="auto" margin="20px" borderRadius="5px" border={border[1]} bgcolor={palette.contentBg} padding="20px">
                        <Typography marginTop="20px" variant='h6'>{t( "attempt.instructions" )}</Typography>
                        <Box marginTop="10px" className='wysiwyg-text-container' borderRadius="10px">
                            <Box dangerouslySetInnerHTML={{ __html: getInstructionByLang( ExamStore.getExam?.instructions ) }} ></Box>
                        </Box>
                        {translationsAvailable && <Box marginTop="20px">
                            <Typography gutterBottom fontWeight={700} fontSize="0.9rem">{t( "label.selectExamLanguage" )}</Typography>
                            <LanguageSelector variant='dark' showNote />
                        </Box>}
                        <Box display="flex" gap="10px" marginTop="50px" flexWrap="wrap">
                            <Button onClick={startExam} disabled={isStarting} variant='contained' color='success' sx={{ textTransform: "capitalize" }} disableElevation > {isStarting ? <Typography display="flex" alignItems="center" gap="5px" fontSize={14}> <CircularProgress size={14} />{t( "button.startingExam" )}</Typography> : <Typography fontSize={14}>{t( "button.startExam" )}</Typography>} </Button>
                            {/* <Button onClick={() => navigate( '/admission-exams' )} disabled={isStarting} variant='outlined' disableElevation color='error' sx={{ textTransform: "capitalize" }}  >{t( "button.returnToExams" )}</Button> */}
                        </Box></Box>
                </Box>

            </Box>
            }

            {error && <TryAgainMessageBlock actions={error.error === "ENDED" ? [{ label: t( "button.checkResults" ), action: navigateToResultsPage, color: "primary" }] : []} err={error.message} code={error.code} getData={getData} />}

            {/* {loading && <DataLoadingSpinner waitingMessage="Loading exam details..." />} */}

            {isExamStarted && <Box onContextMenu={e => e.preventDefault()} flexGrow={1} id='exam-window' display="flex" flexDirection="column" overflow="auto">
                <Box width="0" sx={{ opacity: "0" }} overflow="hidden" height="0" >
                    <input style={{ height: "0 !important", width: "0 !important" }} type="text" ref={fullscreenHelperInputRef} />
                </Box>
                <Box bgcolor="rgba(0,0,0,0.3)" sx={{ position: "fixed", zIndex: "20000", display: Boolean( showWarning ) ? "flex" : "none", alignItems: "center", top: 0, right: 0, bottom: 0, left: 0, justifyContent: "center" }} >
                    <Card>
                        <Box maxWidth="400px">
                            <Box padding="10px 20px" display="flex" flexDirection="column" alignItems="center" gap="20px">
                                <img src={fullScreenImg} width="160px" alt="Full Screen" />
                                <Typography textAlign="center" color="primaryDark.main" variant='subtitle2'>{t( "message.continueInFullscreen" )}</Typography>
                                {/* <Typography textAlign="center" color="primary.main" fontWeight="bolder" variant='subtitle2'>Only {ExcusesCount - faultCount} excuses left</Typography> */}
                            </Box>
                            {/* <Box display="flex" flexDirection="column" margin="0 10px" borderRadius="5px" alignItems="center" justifyContent="center" bgcolor={palette.contentBg} padding="20px">
                                <Typography marginY="10px" textAlign="center" variant='h6' fontWeight="500" fontSize="16px" color="#ED1C24" >YOU HAVE COMMITTED {faultCount} FAULT(S)!</Typography>
                                <Typography textAlign="center" color="GrayText" fontWeight="bolder" variant='subtitle2'>
                                    Ongoing exam will be submitted automatically once the excuses exceeds the limit!
                                </Typography>
                            </Box> */}
                            <Box padding="20px" display="flex" gap="20px" justifyContent="center" alignItems="center" flexWrap="wrap">
                                <Button disabled={isSubmitting} onClick={async ( e ) => {
                                    try {
                                        e?.target?.focus()
                                    } catch ( err ) { }
                                    setShowWarning( null )
                                    enterFullScreen()
                                }} variant='contained' color="customThemeColor" disableElevation sx={{ textTransform: "capitalize" }}>{t( "button.okay" )}</Button>
                                {/* <Button onClick={
                                    async () => {
                                        setIsSubmitting( true )
                                        await finishExam( "ManualSubmission", submissions.length, questions.length )
                                        setIsSubmitting( false )
                                    }}
                                    variant='contained' color="secondary" startIcon={isSubmitting && <CircularProgress size={14} />} disabled={isSubmitting} disableElevation sx={{ textTransform: "capitalize" }}>Finish exam now</Button> */}
                            </Box>
                        </Box>
                    </Card>
                </Box>

                <Button
                    sx={{ position: "fixed", opacity: 0, pointerEvents: "none", width: 0, padding: "0", height: "0" }} onClick={async ( e ) => {
                        try {
                            e?.target?.focus()
                            await examAttemptFullScreenHandle.enter()
                        } catch ( err ) {
                            console.log( err )
                        }
                    }} ref={fullscreeBtnRef}
                ></Button>
                <Box bgcolor="rgba(0,0,0,0.3)" sx={{ position: "fixed", zIndex: "20000", display: finishDialog ? "flex" : "none", alignItems: "center", top: 0, right: 0, bottom: 0, left: 0, justifyContent: "center" }} >
                    <Box bgcolor={palette.common.bg} margin="20px" borderRadius="5px">
                        <Typography color={palette.common.font} padding="10px 20px" borderBottom={border[1]} variant='h6'>{t( "message.areUSure" )}</Typography>
                        <Box padding="20px">
                            <Typography color={palette.common.font} variant='subtitle2' marginBottom="10px">{t( "message.stillHaveTime" )}</Typography>
                            <Box display="flex" gap="10px" marginTop="20px" flexWrap="wrap">
                                <Button color='primaryDark' onClick={async () => { setIsSubmitting( true ); await finishExam( "ManualSubmission", submissions.length, questions.length ); setIsSubmitting( false ) }} disableElevation disabled={isSubmitting} variant='contained' sx={{ textTransform: "capitalize" }}>{isSubmitting ? <Typography display="flex" alignItems="center" gap="5px" fontSize="14px"> <CircularProgress size={14} /> {t( "button.submittingAnswers" )}</Typography> : t( "button.submitAnswers" )}</Button>
                                <Button onClick={() => setFinishDialog( false )} disabled={isSubmitting} variant='contained' disableElevation color="error" sx={{ textTransform: "capitalize" }}>{t( "button.cancel" )}</Button>
                            </Box>
                        </Box>
                    </Box>
                </Box>

                {participation && <ExamAttemptHeader totalPoints={questions?.reduce( ( sum, ques ) => sum + ques.question.question_point, 0 )} totalQuestions={questions?.length || 0} totalSubmissions={submissions?.length || 0} setTimeLeft={setTimeLeft} handleClickOnFinishExam={handleClickOnFinishExam} finishExam={finishExam} />}

                {questionSections?.length > 1 && <Box width="full" paddingY="10px" bgcolor={palette.common.bg}>
                    <Tabs allowScrollButtonsMobile sx={{ marginLeft: "-20px" }} variant='scrollable' scrollButtons value={section} onChange={handleChange} >
                        {questionSections?.map( sectionValue => (
                            <Tab label={sectionValue} value={sectionValue} key={sectionValue} />
                        ) )}
                    </Tabs>
                </Box>}
                {questions && <Box paddingBottom="10px" borderRadius="0 0 10px 10px" display="grid" flexGrow={1} bgcolor={palette.common.bg} overflow="auto" gridTemplateColumns={{ lg: `${showQuestions ? "300px" : "0px"} auto`, md: `${showQuestions ? "250px" : "0px"} auto`, sm: `${showQuestions ? "50px" : "0px"} auto`, xs: `${showQuestions ? "50px" : "0px"} auto` }} sx={{ transition: "0.2s ease-out" }}>
                    <QuestionList showQuestions={showQuestions} questions={filteredQuestions} />
                    <AnswerSection handleClickOnFinishExam={handleClickOnFinishExam} allAnswered={questions?.length === submissions?.length} saving={saving} toggleQuestions={toggleQuestions} showQuestions={showQuestions} submitAnswer={saveAnswer} submissions={submissions} finishExam={finishExam} />
                </Box>}
            </Box >}
        </FullScreen>
    )
} )

export default AdmissionExamAttempt